export const offers = {
  appBarTitle: "العروض",
  addOffer: "أضف عرض جديد",
  deleteOffer: "حذف العرض",
  deleteConfirm:
    "هل أنت متأكد من أنك تريد حذف هذا العرض؟ هذا الإجراء لا يمكن التراجع عنه",
  publishOffer: "نشر العرض",
  publishConfirm:
    "سيؤدي نشر العرض إلى إظهاره إلى المستخدمين. هل أنت متأكد أنك تريد نشر هذا العرض؟",
  unpublishOffer: "إلغاء نشر العرض",
  unpublishConfirm:
    "سيؤدي إلغاء نشر العرض إلى إخفائه من جانب المستخدمين. هل أنت متأكد أنك تريد إلغاء نشر هذا العرض؟",
  markAsServiceOffer: "تعيين كعرض خدمة",
  markAsServiceOfferConfirm: "هل انت متاكد انك تريد تعيين هذا العرض كعرض خدمة ؟",
  removeServiceOffer: "إزالة تصنيف عرض الخدمة",
  removeServiceOfferConfirm: "هل أنت متأكد أنك تريد إزالة تصنيف عرض الخدمة؟",
  noOffers: "لا يوجد عروض حتى الآن",
  offersPerPage: "عدد العروض في الصفحة",
  on: "مفعل",
  off: "غير مفعل",
  card: {
    view: "عرض",
    edit: "تعديل",
    delete: "حذف",
    pending: "قيد الانتظار",
    started: "بدأ",
    expired: "منتهى",
    starts: "يبدأ",
    ends: "ينتهي",
    templateLabel: "قد يكون العرض متاحًا لشركاء متعددين",
    editOfferTooltip: "لا يمكن تعديل العروض المنتهية",
    published: "تم النشر",
    unpublished: "غير منشور",
    publish: "نشر",
    unpublish: "إلغاء النشر",
    serviceOffer: "عرض خدمات",
  },
  filters: {
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    status: "الحالة",
    pending: "قيد الانتظار",
    started: "بدأ",
    expired: "منتهى",
    carMake: "ماركة العربية",
    carType: "نوع العربية",
  },
  offerForm: {
    createTitle: "إنشاء عرض",
    editTitle: "تعديل عرض",
    serviceOffer: "عرض خدمات",
    create: "إنشاء",
    edit: "تعديل",
    offerBanner: "رفع بانر العرض",
    hotOfferBanner: "رفع بانر العرض المميز",
    hotOfferToggle: "عرض مميز",
    titleEn: "عنوان العرض بالإنجليزية",
    titleAr: "عنوان العرض بالعربية",
    descEn: "وصف العرض بالإنجليزية",
    descAr: "وصف العرض بالعربية",
    startDate: "تاريخ بدء العرض",
    endDate: "تاريخ انتهاء العرض",
    carMakes: "ماركات العربيات",
    carTypes: "أنواع العربيات",
    all: "الجميع",
    pinToExplore: "إظهار في استكشف",
    addCTAButton: "إضافة زر الدعوة لاتخاذ إجراء إلى العرض",
    ctaRedirectionPage: "صفحة إعادة التوجيه لزر الدعوة لاتخاذ إجراء",
    offerId: "رقم العرض",
    redirectionURl: "رابط إعادة التوجيه",
    promocodesOfferId: "رقم عرض الرمز الترويجي",
    ctaNameEn: "اسم زر الدعوة لاتخاذ إجراء بالإنجليزية",
    ctaNameAr: "اسم زر الدعوة لاتخاذ إجراء بالعربية",
    nationalIdVerificationRequired:"يتطلب التحقق من الرقم القومي",
    validation: {
      titleEnReq: "عنوان العرض بالإنجليزية مطلوب",
      titleEnValid: "عنوان العرض بالإنجليزية لا يسمح بالأحرف العربية",
      titleEnMax: "عنوان العرض بالإنجليزية يجب أن يكون أقل من أو يساوي 160 حرف",
      titleArReq: "عنوان العرض بالعربية مطلوب",
      titleArValid: "عنوان العرض بالعربية لا يسمح بالأحرف الإنجليزية",
      titleArMax: "عنوان العرض بالعربية يجب أن يكون أقل من أو يساوي 160 حرف",
      descEnReq: "وصف العرض بالإنجليزية مطلوب",
      descEnValid: "وصف العرض بالإنجليزية لا يسمح بالأحرف العربية",
      descEnMax: "وصف العرض بالإنجليزية يجب أن يكون أقل من أو يساوي 5000 حرف",
      descArReq: "وصف العرض بالعربية مطلوب",
      descArValid: "وصف العرض بالعربية لا يسمح بالأحرف الإنجليزية",
      descArMax: "وصف العرض بالعربية يجب أن يكون أقل من أو يساوي 5000 حرف",
      startDateReq: "تاريخ بدء العرض مطلوب",
      endDateReq: "تاريخ انتهاء العرض مطلوب",
      startDateMin: "تاريخ بدء العرض يجب أن يكون تاريخًا قادمًا",
      endDateMin: "تاريخ انتهاء العرض يجب أن يكون بعد تاريخ بدئه",
      startDateType: "تاريخ بدء العرض يجب أن يكون تاريخ صحيح",
      endDateType: "تاريخ انتهاء العرض يجب أن يكون تاريخ صحيح",
      carMakesReq: "اختر ماركة سيارة واحدة على الأقل أو يمكنك اختيار الكل",
      carTypesReq: "اختر نوع سيارة واحد على الأقل أو يمكنك اختيار الكل",
      bannerReq: "بانر العرض مطلوب",
      hotOfferBannerReq: "بانر العرض المميز مطلوب",
      ctaRedirectionPageReq:
        "صفحة إعادة التوجيه لزر الدعوة لاتخاذ إجراء مطلوبه",
      offerIdReq: "رقم العرض مطلوب",
      redirectionURlReq: "رابط إعادة التوجيه مطلوب",
      redirectionURlValid: "رابط إعادة التوجيه غير صالح",
      promocodesOfferIdReq: "رقم عرض الرمز الترويجي مطلوب",
      ctaNameTextOnly:
        "إدخال غير صالح: هذا الحقل يقبل الحروف والرموز الخاصة فقط. يرجى إزالة أي أرقام أو علامات.",
      ctaNameEnReq: "اسم زر الدعوة لاتخاذ إجراء بالإنجليزية مطلوب",
      ctaNameEnValid:
        "اسم زر الدعوة لاتخاذ إجراء بالإنجليزية لا يسمح بالأحرف العربية و الأرقام",
      ctaNameEnMax:
        "اسم زر الدعوة لاتخاذ إجراء بالإنجليزية يجب أن يكون أقل من أو يساوي 30 حرف",
      ctaNameArReq: "اسم زر الدعوة لاتخاذ إجراء بالعربية مطلوب",
      ctaNameArValid:
        "اسم زر الدعوة لاتخاذ إجراء بالعربية لا يسمح بالأحرف الإنجليزية و الأرقام",
      ctaNameArMax:
        "اسم زر الدعوة لاتخاذ إجراء بالعربية يجب أن يكون أقل من أو يساوي 30 حرف",
    },
  },
  offerDetails: {
    offerDetails: "تفاصيل العرض",
    published: "تم النشر",
    unpublished: "غير منشور",
    serviceOffer: "عرض خدمة",
    serviceOfferMarked: "تم تعليم العرض كعرض خدمة",
    serviceOfferRemoved: "تمت إزالة علامة عرض الخدمة",
    publish: "نشر",
    unpublish: "إلغاء النشر",
    all: "الجميع",
    titleEn: "عنوان العرض بالإنجليزية",
    titleAr: "عنوان العرض بالعربية",
    descEn: "وصف العرض بالإنجليزية",
    descAr: "وصف العرض بالعربية",
    startDate: "تاريخ بدء العرض",
    endDate: "تاريخ انتهاء العرض",
    carMakes: "ماركات العربيات",
    carTypes: "أنواع العربيات",
    pending: "قيد الانتظار",
    started: "بدأ",
    expired: "منتهى",
    offerDates: "تواريخ العرض",
    theCtaButtonStatus: "حالة  زر الدعوة لاتخاذ إجراء",
    theCtaRedirectionPage: "صفحة إعادة التوجيه لزر الدعوة لاتخاذ إجراء",
    redirectionURl: "رابط إعادة التوجيه",
    loyalityOfferId: "رقم العرض",
    promocodesOfferId: "رقم عرض الرمز الترويجي",
    theCtaNameEn: "اسم زر الدعوة لاتخاذ إجراء بالإنجليزية",
    theCtaNameAr: "اسم زر الدعوة لاتخاذ إجراء بالعربية",
    hotOfferToggle: "عرض مميز",
    offerBanner:"بانر العرض",
    hotOfferBanner:"بانر العرض المميز",
    hotOfferConfirm: "سيتم تمييز هذا العرض كمميز للمستخدمين. هل أنت متأكد أنك تريد تمييز هذا العرض كمميز؟",
    hotOfferRemoveConfirm: "سيتم إزالة تمييز هذا العرض كمميز. هل أنت متأكد أنك تريد إزالة التمييز؟",
    hotOfferMark: "تمييز العرض كمميز",
    hotOfferRemove: "إزالة تمييز العرض كمميز",
    hotOfferMarked: "تم تمييز العرض كمميز بنجاح",
    hotOfferRemoved: "تمت إزالة العرض من العروض المميزة بنجاح",
    hotOfferDisabledTooltip: "يجب نشر هذا العرض أولاً قبل تحديده كعرض مميز.",
    flagAsServicesOffer: "تمييز العرض كخدمات",
    uploadHotOfferBanner: "يرجى رفع صورة العرض المميز قبل تفعيل هذا الخيار.",
    nationalIdVerificationRequired: "يتطلب التحقق من الرقم القومي",
  },
};
